/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
import { Form } from 'antd';
import { Rule } from 'antd/es/form';
import PrefixOrSuffixInput from 'presentation/components/PrefixOrSuffixInput';
import React, { useEffect, useState } from 'react';
import getMessage from 'utilities/constants/MESSAGE';
import { commonHelpers } from 'utilities/helpers';

type props = {
    style?: React.CSSProperties;
    name?: string;
    placeholder?: string;
    suffix?: any;
    disabled?: any;
    maxLength?: number;
    required?: boolean;
    fraction?: boolean;
    callback?: Function;
    max?: number | string;
    min?: number | string;
    subtract?: boolean;
    rules?: Rule[];
    label: string;
    defaultValue?: number | string;
    purchaseValue?: number | string;
};

const InputAllowNumber = ({
    name,
    style,
    placeholder,
    suffix,
    maxLength,
    disabled,
    fraction,
    callback,
    min,
    max,
    subtract,
    rules,
    label,
    defaultValue,
    purchaseValue, // 新しく追加したプロパティ
}: props) => {
    const [value, setValue] = useState<any>(''); // 初期値は空

    const [isRequire, setIsRequire] = useState<boolean>(false);
    useEffect(() => {
        if (purchaseValue) {
            setValue(Number(purchaseValue).toLocaleString('en-US', { maximumFractionDigits: 3 }));
        } else if (defaultValue) {
            setValue(Number(defaultValue).toLocaleString('en-US', { maximumFractionDigits: 3 }));
        }
    }, [purchaseValue, defaultValue]);

    // 必須項目の設定
    useEffect(() => {
        if ((rules?.length ?? 0) > 0) {
            rules?.forEach((rule: any) => {
                if (rule.required) {
                    setIsRequire(true);
                }
            });
        }
    }, [rules]);

    // バリデーションルールを設定
    useEffect(() => {
        const minValue = Number(min);
        let maxValue = Number(max);
        if (!max && maxLength) {
            maxValue = Math.pow(10, maxLength) - 1;
        }

        if (minValue && rules?.findIndex((rule: any) => rule.id === 'min') === -1) {
            rules?.push(() => ({
                id: 'min',
                validator(_: any, val: any) {
                    let validateValue = val;
                    if (validateValue && isNaN(validateValue)) {
                        validateValue = Number((validateValue + '').replaceAll(',', ''));
                    }
                    if ((validateValue || validateValue === 0) && !isNaN(validateValue)) {
                        if (Number(validateValue) < minValue) {
                            return Promise.reject(
                                getMessage('In_ValRng_FromTo', label, commonHelpers.formatNumberMoney(min), commonHelpers.formatNumberMoney(max ? max : maxValue)),
                            );
                        }
                    }
                    return Promise.resolve();
                },
            }));
        }

        if (maxValue && rules?.findIndex((rule: any) => rule.id === 'max') === -1) {
            rules?.push(() => ({
                id: 'max',
                validator(_: any, val: any) {
                    let validateValue = val;
                    if (validateValue && isNaN(validateValue)) {
                        validateValue = Number((validateValue + '').replaceAll(',', ''));
                    }
                    if ((validateValue || validateValue === 0) && !isNaN(validateValue)) {
                        if (Number(validateValue) > maxValue) {
                            return Promise.reject(
                                getMessage(
                                    'In_ValRng_FromTo',
                                    label,
                                    commonHelpers.formatNumberMoney(min),
                                    commonHelpers.formatNumberMoney(maxValue),
                                ),
                            );
                        }
                    }
                    return Promise.resolve();
                },
            }));
        }
    }, [rules, min, max, maxLength, label]);

    return (
        <>
            <span>
                {label}
                {isRequire && <span style={{ color: '#EB5757' }}>*</span>}
            </span>
            <Form.Item name={name} rules={rules}>
                <PrefixOrSuffixInput
                    style={style}
                    placeholder={placeholder}
                    suffix={suffix}
                    maxLength={maxLength}
                    disabled={disabled}
                    Value={value}
                    onChange={setValue}
                    fraction={fraction}
                    callback={callback}
                    subtract={subtract}
                />
            </Form.Item>
        </>
    );
};

export default InputAllowNumber;
